/**
 * @fileoverview gRPC-Web generated client stub for mlmbox.client.locale.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.8
// source: mlmbox/client/locale/v1/locale.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var mlmbox_type_locale_pb = require('../../../../mlmbox/type/locale_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.mlmbox = {};
proto.mlmbox.client = {};
proto.mlmbox.client.locale = {};
proto.mlmbox.client.locale.v1 = require('./locale_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.locale.v1.LocaleClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.locale.v1.LocalePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.type.Locale.ID,
 *   !proto.mlmbox.type.Locale>}
 */
const methodDescriptor_Locale_Get = new grpc.web.MethodDescriptor(
  '/mlmbox.client.locale.v1.Locale/Get',
  grpc.web.MethodType.UNARY,
  mlmbox_type_locale_pb.Locale.ID,
  mlmbox_type_locale_pb.Locale,
  /**
   * @param {!proto.mlmbox.type.Locale.ID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_locale_pb.Locale.deserializeBinary
);


/**
 * @param {!proto.mlmbox.type.Locale.ID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Locale)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Locale>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.locale.v1.LocaleClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.locale.v1.Locale/Get',
      request,
      metadata || {},
      methodDescriptor_Locale_Get,
      callback);
};


/**
 * @param {!proto.mlmbox.type.Locale.ID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Locale>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.locale.v1.LocalePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.locale.v1.Locale/Get',
      request,
      metadata || {},
      methodDescriptor_Locale_Get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.mlmbox.type.Locale>}
 */
const methodDescriptor_Locale_List = new grpc.web.MethodDescriptor(
  '/mlmbox.client.locale.v1.Locale/List',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_empty_pb.Empty,
  mlmbox_type_locale_pb.Locale,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_locale_pb.Locale.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Locale>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.locale.v1.LocaleClient.prototype.list =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.locale.v1.Locale/List',
      request,
      metadata || {},
      methodDescriptor_Locale_List);
};


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Locale>}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.locale.v1.LocalePromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/mlmbox.client.locale.v1.Locale/List',
      request,
      metadata || {},
      methodDescriptor_Locale_List);
};


module.exports = proto.mlmbox.client.locale.v1;

